export { FilterX as default } from './FilterX';
